document.addEventListener("DOMContentLoaded", function () {
    initializeFooterCollapsibles()
    initslider()
  });

function initslider() {
    const productSliders = document.querySelectorAll('.collection-toolbar__category-list');
    productSliders.forEach((slider) => {

        new Swiper(slider, {
            navigation: false,
            pagination: false,
            slidesPerView: 'auto',
            spaceBetween: 20,
            grabCursor: true,
        });
    });
}

function initializeFooterCollapsibles() {
    const collapsibleTriggers = document.querySelectorAll(".collapsible-trig");
  
    // Only run on mobile (less than 700px)
    if (window.innerWidth >= 700) return;
  
    collapsibleTriggers.forEach((trigger, index) => {
      const collapsibleContent = trigger.nextElementSibling;
  
      // Set the first collapsible open on load
      if (index === 0 && !trigger.classList.contains("initialized")) {
        const contentHeight = collapsibleContent.scrollHeight;
        collapsibleContent.style.maxHeight = contentHeight + "px";
        trigger.classList.add("open");
      }
  
      // Prevent re-initializing
      trigger.classList.add("initialized");
  
      // Add click event listener for toggling
      trigger.addEventListener("click", function () {
        const isOpen = trigger.classList.contains("open");
  
        if (isOpen) {
          // Close the clicked collapsible
          collapsibleContent.style.maxHeight = null;
          trigger.classList.remove("open");
        } else {
          // Open the clicked collapsible
          const contentHeight = collapsibleContent.scrollHeight;
          collapsibleContent.style.maxHeight = contentHeight + "px";
          trigger.classList.add("open");
        }
      });
    });
  }
  